import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/api/system/menu/index',
    method: 'get',
    params,
  })
}
